import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=1b947183&"
import script from "./navmenu.js?vue&type=script&lang=js&"
export * from "./navmenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b947183')) {
      api.createRecord('1b947183', component.options)
    } else {
      api.reload('1b947183', component.options)
    }
    module.hot.accept("./navmenu.vue?vue&type=template&id=1b947183&", function () {
      api.rerender('1b947183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/navmenu/navmenu.vue"
export default component.exports